var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5.458c-1.036 0-1.875.84-1.875 1.875a.625.625 0 11-1.25 0 3.125 3.125 0 116.25 0c0 .665-.206 1.17-.532 1.568-.294.36-.674.613-.968.809l-.028.018c-.327.218-.558.377-.723.58-.142.173-.249.398-.249.775a.625.625 0 11-1.25 0c0-.664.206-1.169.532-1.567.294-.36.674-.613.968-.81l.028-.018c.327-.218.558-.377.723-.579.142-.174.249-.398.249-.776 0-1.035-.84-1.875-1.875-1.875zM9 14a.833.833 0 100-1.667A.833.833 0 009 14z",
    fill: "#000",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.333A8.333 8.333 0 109 .667a8.333 8.333 0 000 16.666zm0-1.25A7.083 7.083 0 109 1.917a7.083 7.083 0 000 14.166z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgQuestionCircle;